module.exports = __webpack_public_path__ + "img/supporting_doc_icon.79c2e0e0.svg";